export default __webpack_public_path__ + "static/media/the-pig.17301e35.svg";